var map = {
	"./workingcalendar_2018.ics": 5186,
	"./workingcalendar_2019.ics": 4483,
	"./workingcalendar_2020.ics": 6559,
	"./workingcalendar_2021.ics": 578,
	"./workingcalendar_2022.ics": 6543,
	"./workingcalendar_2023.ics": 1076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3781;